import { useState } from 'react';

import {
  Box,
  ClickAwayListener,
  Tooltip,
  type TooltipProps,
} from '@mui/material';

import { useIsMobile } from '@/hooks/useBreakpoints';

const CustomTooltip = ({ children, sx, ...props }: TooltipProps) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleTooltipClose = () => {
    setOpen(false);
  };

  if (isMobile) {
    return (
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClose={handleTooltipClose}
          slotProps={{
            popper: {
              sx: {
                '.MuiTooltip-tooltipPlacementTop': {
                  mb: '12px !important',
                },
                '.MuiTooltip-tooltipPlacementBottom': {
                  mt: '12px !important',
                },
                '.MuiTooltip-tooltipPlacementLeft': {
                  mr: '12px !important',
                },
                '.MuiTooltip-tooltipPlacementRight': {
                  ml: '12px !important',
                },
              },
            },
          }}
          {...props}
        >
          <Box
            component="span"
            sx={{ display: 'inline', ...sx }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpen(true);
            }}
          >
            {children}
          </Box>
        </Tooltip>
      </ClickAwayListener>
    );
  }

  return (
    <Tooltip {...props}>
      <Box
        component="span"
        sx={{ cursor: 'pointer', display: 'inline', ...sx }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default CustomTooltip;
